<h2 class="title">Panel użytkownika</h2>
<div class="person-edit-container">

  <!-- Privacy Policy Acceptance Section -->
  @if (!isAcceptedPolicy) {
    <div class="policy-acceptance-section">
      <div class="warning-message" style="color: #c62828; padding: 15px; background: #ffebee; border-radius: 4px; margin-bottom: 20px;">
        <strong>Uwaga:</strong> Aby korzystać z programu ZGrane Grono, musisz zaakceptować regulamin.
      </div>
      <form [formGroup]="acceptForm">
        <div class="checkbox-container">
          <mat-checkbox formControlName="acceptPolicy" (change)="onPolicyAcceptanceChange()">
            Oświadczam, że zapoznałem/am się z regulaminem Programu ZGrane Grono.
            <span (click)="$event.stopPropagation(); $event.preventDefault()" (mousedown)="$event.stopPropagation()">
              <app-info-help [pageId]="'polityka_prywatnosci'" [title]="'Polityka prywatności'">
              </app-info-help>
            </span>
          </mat-checkbox>
          @if (acceptForm.get('acceptPolicy')?.invalid && acceptForm.get('acceptPolicy')?.touched) {
            <div class="error-message"
              style="color: #c62828; margin-top: 5px;">
              Musisz zaakceptować politykę prywatności
            </div>
          }
        </div>
      </form>
    </div>
  }

  <!-- Loading State -->
  @if (loading) {
    <div class="loading-container">
      <mat-progress-spinner diameter="50"></mat-progress-spinner>
      <p>Ładowanie danych mieszkańca...</p>
    </div>
  }

  <!-- Error State -->
  @if (!loading && !person && isAcceptedPolicy) {
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <p>Nie udało się załadować danych mieszkańca</p>
      <button mat-raised-button class="custom-button" (click)="loadPersonData()">
        <mat-icon>refresh</mat-icon>
        Spróbuj ponownie
      </button>
    </div>
  }

  <!-- Person Data Tabs -->
  @if (!loading && person && isAcceptedPolicy) {
    <div class="person-tabs-container">
      <div class="person-header">
        <div class="header-content">
          <h3  >
            @if (!isNewPerson) {
              <span>{{person.name}} {{person.surname}}</span>
            }
            @if (isNewPerson) {
              <span>Nowy wniosek</span>
            }
          </h3>
        </div>
      </div>
      <div class="tabs-container">
      <mat-tab-group class="tabs-holder" [(selectedIndex)]="selectedTabIndex">
        <mat-tab label="Dane mieszkańca">
          <person-data
            (personChanged)="onPersonChanged($event)"
            (personSaved)="onPersonSaved($event)"
            [person]="person">
          </person-data>
        </mat-tab>
        <!--
        <mat-tab label="Twoje Dokumenty" [disabled]="isNewPerson">
          <ng-container *ngIf="person && person.id && !isNewPerson">
            <files-list [personId]="person.id"></files-list>
          </ng-container>
        </mat-tab>
        -->
        <mat-tab
          label="Rodzina"
          [disabled]="person.type !== 'CHILDREN'">
          @if (person && person.id) {
            <app-family
              (personChanged)="onPersonChanged()"
              (childChanged)="onChildChanged()"
              [parent]="person">
            </app-family>
          }
        </mat-tab>
        @if (person && person.cards && person.cards.length > 0) {
         <mat-tab
          label='Twoje Karty'
          [disabled]="!person || !person.id">
          @if (person && person.id) {
            <list-app-cards [person]="person"></list-app-cards>
          }
        </mat-tab>
       } @else  {
        <mat-tab
          label='Zamów Kartę'
          [disabled]="!person || !person.id">
          @if (person && person.id) {
            <list-app-cards [person]="person"></list-app-cards>
          }
        </mat-tab>
       }
      </mat-tab-group>
      </div>
    </div>
  }
</div>
